import { EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { FeatureFlags } from '../../feature-flags/feature-flags';

import { SET_FLAGS } from './actions';
import { PusherService } from '../../services/pusher-service';

export const updatePusherWhenFeatureFlagsChange = (action$, { getState }) => {
  return action$.pipe(
    ofType(SET_FLAGS),
    mergeMap(() => {
      // we will set the active socket key when pusher finishes initializing
      // so just return early if it is not yet done when we get here
      if (!PusherService._isInitialized) {
        return EMPTY;
      }
      const state = getState();
      const { primaryPusherApp: pusherAppKey } = new FeatureFlags({ state });

      PusherService.setActiveSocketKey(pusherAppKey);

      return EMPTY;
    }),
  );
};
